$(function(){
  $(document).on('click', '.menu_status a[data-method="delete"]', function(event){
    event.preventDefault();
    clearLocalStorage();
    $.ajax({
      url: this.getAttribute('href'),
      type: 'DELETE',
    }).done(function (data) {
      window.location.href = Routes.new_user_session_path();
    });
  });

  function clearLocalStorage() {
    localStorage.removeItem('jobs_favorite');
  }
});